import { Box, OutlinedInput, TableCell, Typography } from "@material-ui/core";
import { FalconPlanData, FalconStandardData, FalconTableRow } from "types/Falcon";
import { formatNumberType } from "utils/formatNumbers";
import { AlertBlock } from "componentsNew/elements/AlertBlock";
import { inputNumberValidateOnPaste } from "utils/formats";

export const RenderFalconCell = (
  classes: { [key: string]: string },
  tableRow: FalconTableRow,
  falconData: FalconStandardData[],
  falconPlanData: FalconPlanData[],
  editMode: boolean,
  typeFalconPlanData: FalconPlanData[],
  setTypePlanData: any,
  columnDate?: string | number | undefined,
) => {
  switch (tableRow.id) {
    case "planned":
      const planRoutes = falconPlanData.reduce(
        (a: number, b: FalconPlanData) => a + b.number_of_routes,
        0,
      );
      return (
        <TableCell
          key={`${tableRow.id}${columnDate}`}
          className={`${classes.tablePlanCell} ${classes.frameBorderTop}`}
          colSpan={2}
        >
          <Typography
            style={{ fontWeight: 600 }}
            className={`${classes.tableCellContent} ${classes.borderCellRight}`}
          >
            {planRoutes}
          </Typography>
        </TableCell>
      );
    case "large-van":
    case "box-truck":
      const planTypeRoutes = typeFalconPlanData.reduce(
        (a: number, b: FalconPlanData) => a + b.number_of_routes,
        0,
      );
      return (
        <TableCell
          key={`${tableRow.id}${columnDate}`}
          className={`${classes.tablePlanCell} ${classes.frameBorderTop}`}
          colSpan={2}
        >
          <Box className={`${classes.tableCellContent} ${classes.borderCellRight}`}>
            {editMode ? (
              <OutlinedInput
                autoFocus
                className={classes.input}
                value={planTypeRoutes}
                onChange={(e) => {
                  setTypePlanData((prevList: FalconPlanData[]) =>
                    prevList.map((item) =>
                      item.report_date === columnDate && item.type === tableRow.id
                        ? { ...item, number_of_routes: Number(e.target.value) }
                        : item,
                    ),
                  );
                }}
                onPaste={inputNumberValidateOnPaste}
              />
            ) : (
              <Typography style={{ fontWeight: 600 }}>{planTypeRoutes}</Typography>
            )}
          </Box>
        </TableCell>
      );
    case "actual-billed":
      const routesSum = falconData
        .filter(
          (item: FalconStandardData) =>
            ([0].includes(item.role) && [1, 2, 5, 6, null].includes(item.van__fleet_size)) ||
            ([8].includes(item.role) && [1, 2, 5, 6].includes(item.van__fleet_size)),
        )
        .reduce((a: number, b: FalconStandardData) => a + b.routes, 0);
      return (
        <TableCell
          key={`${tableRow.id}${columnDate}`}
          className={`${classes.tableCell}`}
          colSpan={2}
        >
          <Typography
            style={{ fontWeight: 600 }}
            className={`${classes.tableCellContent} ${classes.borderCellRight}`}
          >
            {routesSum > 0 ? routesSum : "0"}
          </Typography>
        </TableCell>
      );

    case "difference":
      const plan = falconPlanData.reduce(
        (a: number, b: FalconPlanData) => a + b.number_of_routes,
        0,
      );
      const actual = falconData
        ?.filter((item: FalconStandardData) => tableRow.roles?.includes(item.role))
        .reduce((a: number, b: FalconStandardData) => a + b.routes, 0);
      const diference = plan > 0 ? (100 * actual) / plan : (100 * actual) / 1;

      return (
        <TableCell
          key={`${tableRow.id}${columnDate}`}
          className={`${classes.tableBottomCell}`}
          colSpan={2}
        >
          <Box className={`${classes.tableCellContent} ${classes.borderCellRight}`}>
            <AlertBlock
              text={`${formatNumberType(Number(diference))}%`}
              theme={plan <= actual ? "success" : "error"}
            />
          </Box>
        </TableCell>
      );
    case "client-cancelled-cargo":
    case "client-cancelled-large":
    case "client-cancelled-cube":
    case "client-cancelled-medium":
    case "mycu-cancelled-cargo":
    case "mycu-cancelled-large":
    case "mycu-cancelled-cube":
    case "mycu-cancelled-medium":
      const cancelledRoutes = falconData
        ?.filter(
          (item: FalconStandardData) =>
            tableRow.role === item.role &&
            tableRow?.vans?.includes(
              item?.van__fleet_size ? item?.van__fleet_size : item?.cancelled_fleet_size,
            ),
        )
        .reduce((a: number, b: FalconStandardData) => a + b.routes, 0);

      return (
        <TableCell
          key={`${tableRow.id}${columnDate}`}
          className={`${classes.tableCell}`}
          colSpan={2}
        >
          <Typography className={`${classes.tableCellContent} ${classes.borderCellRight}`}>
            {cancelledRoutes > 0 ? cancelledRoutes : "---"}
          </Typography>
        </TableCell>
      );

    default:
      const routes = falconData
        .filter(
          (item: FalconStandardData) =>
            item?.role === tableRow.role &&
            tableRow?.vans?.includes(item?.van__fleet_size) &&
            tableRow.hour?.includes(item?.role_hours),
        )
        ?.reduce((a: number, b: FalconStandardData) => a + b.routes, 0);

      return (
        <TableCell
          key={`${tableRow.id}${columnDate}`}
          className={`${classes.tableCell}`}
          colSpan={2}
        >
          <Typography className={`${classes.tableCellContent} ${classes.borderCellRight}`}>
            {routes > 0 ? routes : "---"}
          </Typography>
        </TableCell>
      );
  }
};
